import React from 'react';
import styled from 'styled-components';

const Track = styled.div<{ $active?: boolean; $color?: string }>`
  margin-left: auto;
  width: 32px;
  height: 18px;
  border-radius: 9px;
  background: ${({ $active, $color, theme }) =>
    $active ? ($color || theme.send_button_bg) : (theme.mode === 'dark' ? 'rgba(255,255,255,0.15)' : 'rgba(0,0,0,0.12)')};
  position: relative;
  transition: background 0.2s ease;
  flex-shrink: 0;
`;

const Thumb = styled.div<{ $active?: boolean }>`
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background: white;
  position: absolute;
  top: 2px;
  left: ${({ $active }) => ($active ? '16px' : '2px')};
  transition: left 0.2s ease;
`;

export interface ToggleSwitchProps {
  active?: boolean;
  /** Cor da pílula quando ativa. Default: theme.send_button_bg. */
  color?: string;
  className?: string;
}

/** Switch on/off compartilhado (input do chat + menu do usuário). */
export const ToggleSwitch: React.FC<ToggleSwitchProps> = ({ active, color, className }) => (
  <Track $active={active} $color={color} className={className}>
    <Thumb $active={active} />
  </Track>
);

export default ToggleSwitch;
